export default class Modal {
    constructor() {
        this.init();
    }

    init() {
        this.modal();
        this.imageModal();
    }

    modal() {
        const $open_trigger = document.querySelectorAll(".js-modal__open");
        const $close_trigger = document.querySelectorAll(".js-modal__close");

        $close_trigger.forEach((el) => {
            const modals = document.querySelectorAll(".js-modal");

            el.addEventListener("click", () => {
                //自分自身の親のみ閉じる
                el.parentNode.classList.remove("-active");
            });
        });

        $open_trigger.forEach((el) => {
            const tgt = el.getAttribute("data-modal");
            const modal = document.querySelector(`.js-modal[data-modal="${tgt}"]`);

            el.addEventListener("click", () => {
                modal.classList.add("-active");
            });
        });
    }

    imageModal() {
        const $open_trigger = document.querySelectorAll(".js-image__open");
        const $close_trigger = document.querySelectorAll(".js-image__close");

        $open_trigger.forEach((el) => {
            const data = el.getAttribute("data-image");
            const width = el.getAttribute("data-width");
            const height = el.getAttribute("data-height");

            el.addEventListener("click", () => {
                const dom = document.querySelector(".js-imagedom");
                if (window.innerWidth <= 768) {
                    dom.style.height = `${(height / width) * 100}vw`;
                    dom.style.width = `100vw`;
                } else {
                    dom.style.height = `${height}px`;
                    dom.style.width = `${width}px`;
                }
                dom.style.background = `url(${data}) no-repeat 0 0 / 100% auto`;
            });
        });

        $close_trigger.forEach((el) => {
            const dom = document.querySelector(".js-imagedom");
            dom.style.height = `0px`;
            dom.style.width = `0px`;
            dom.style.background = `transparent`;
        });
    }
}
